import keyMirror from 'keymirror'

export default keyMirror({
  GET_ODOO_SYNCHRONIZATIONS_REQUEST: null,
  GET_ODOO_SYNCHRONIZATIONS_SUCCESS: null,
  GET_ODOO_SYNCHRONIZATIONS_FAILED: null
})
